// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CompleteChatFileUploadMutationVariables = Types.Exact<{
  fileId: Types.Scalars['ID']['input'];
}>;


export type CompleteChatFileUploadMutation = { __typename?: 'Mutation', completeChatFileUpload: { __typename?: 'ChatFile', id: string, sessionId: string, messageId?: string | null, origin: Types.ChatFileOrigin, status: Types.ChatFileStatus, fileName: string, mimeType?: string | null, size?: number | null, width?: number | null, height?: number | null, failureCode?: string | null, operationId?: string | null, createdAt: any } };


export const CompleteChatFileUploadDocument = gql`
    mutation CompleteChatFileUpload($fileId: ID!) {
  completeChatFileUpload(fileId: $fileId) {
    id
    sessionId
    messageId
    origin
    status
    fileName
    mimeType
    size
    width
    height
    failureCode
    operationId
    createdAt
  }
}
    `;

/**
 * __useCompleteChatFileUploadMutation__
 *
 * To run a mutation, you first call `useCompleteChatFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChatFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChatFileUploadMutation, { data, loading, error }] = useCompleteChatFileUploadMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useCompleteChatFileUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteChatFileUploadMutation, CompleteChatFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteChatFileUploadMutation, CompleteChatFileUploadMutationVariables>(CompleteChatFileUploadDocument, options);
      }
export type CompleteChatFileUploadMutationHookResult = ReturnType<typeof useCompleteChatFileUploadMutation>;
export type CompleteChatFileUploadMutationResult = ApolloReactCommon.MutationResult<CompleteChatFileUploadMutation>;